import { ofType } from 'redux-observable';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_SPESA_LIST } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  storeSpesaListAction,
} from '../../data.action';
import { filler } from '../../../../../utils/utils';

const retrieveSpesaListEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_SPESA_LIST),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_SPESA_LIST}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, _state]) => {
      return concat(
        of(setLoaders({ incaricoLoader: true })),
        of(setListConfigAction({ spesa: body })),
        defer(() =>
          from(
            request({
              path: `spesa/list`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return { total: p?.total, result: [...p?.result, ...filler] };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_SPESA_LIST}]`, p)),
            // switchMap(() => EMPTY),
            switchMap((data) => of(storeSpesaListAction(data))),
            catchError((err) => {
              console.error(`[epic ${RETRIEVE_SPESA_LIST}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ incaricoLoader: false }))
      );
    })
  );

export default retrieveSpesaListEpic;
